import { render, staticRenderFns } from "./ValidateTsFooter.vue?vue&type=template&id=e8f0a7ce&scoped=true&"
import script from "./ValidateTsFooter.vue?vue&type=script&lang=js&"
export * from "./ValidateTsFooter.vue?vue&type=script&lang=js&"
import style0 from "./ValidateTsFooter.vue?vue&type=style&index=0&id=e8f0a7ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f0a7ce",
  null
  
)

export default component.exports